module.exports = __webpack_public_path__ + "static/photo9@2x-23af9714499aab8165da538f24bdfcd7.png";